<div class="blog-area">
  <div class="blog-wrapper">
    <div class="blog-header">
      <h1>Blog</h1>
      <div class="blog-search-input">
        <input type="search" [(ngModel)]="searchText" placeholder="Search for an answer to your health and wellbeing questions...?">
        <button class="search-icon">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
    <div class="blogs-group">
      <div class="blogs-list">
        <div class="blog-body">
          <ng-container *ngFor="let blog of getPostList(); let i = index">
            <div class="blog-item" [ngClass]="{'full-width': (i === 0 || (i === 5 && ((5) % 2) === 1))}">
              <div class="blog-item-image">
                <img loading="lazy" src="{{blog.images.medium}}" alt="{{getTagsById(blog.categories[0])}}">
                <div class="blog-item-tag">{{getTagsById(blog.categories[0])}}</div>
              </div>
              <div class="blog-item-content">
                <h3 [innerHtml]="blog.title.rendered"></h3>
                <div class="blog-item-by">
                  <p>by <span>{{getUserById(blog.author)}}</span></p>
                  <p class="blog-item-posted-on">{{getDateFormat(blog.modified)}}</p>
                </div>
                <p class="blog-item-post-content" [innerHtml]="blog.excerpt.rendered"></p>
                <a class="blog-item-post-button" [href]="blog.link" target="_blank">
                  Read more <img src="assets/images/arrow-back.svg" alt="arrow-back">
                </a>
              </div>
            </div>
          </ng-container>


        </div>
        <div class="paginationGroup {{startPage > 1 ? 'moreGroup' : ''}}" *ngIf="!searchText && checkPages()">
          <div (click)="prevPage()" class="prevNextBtn"><span>&lt;&lt; Previous
          </span></div>
          <ng-container *ngIf="startPage > 1">
            <div class="page" (click)="updatePage(1)"> 1 </div>
            <div>...</div>
          </ng-container>
          <ng-container *ngFor="let item of [].constructor(endPage); let i = index">
            <ng-container *ngIf="startPage - 1 <= i">
              <div class="page" [ngClass]="{'active': currentPage === i + 1}" (click)="updatePage(i + 1)">{{i + 1}}</div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="endPage < totalPage">
            <div>...</div>
            <div class="page"  (click)="updatePage(totalPage)"> {{totalPage}} </div>

          </ng-container>
          <div (click)="nextPage()" class="prevNextBtn">
            <span>Next >></span>
          </div>
        </div>
        <div class="fetching-blogs" *ngIf="responseReceived && !searchText && !checkPages()">
          Fetching more posts...
        </div>
        <div class="row">
          <button class="read-more-btn" *ngIf="blogPosts.length > 0 && !searchText && !(postLoadCount === blogPosts.length)" (click)="readMorePosts()">Read more</button>
        </div>
      </div>
      <div class="blog-categories">
        <h3>Read more blogs on</h3>
        <ul class="items" #catContainer>
          <ng-container *ngFor="let category of postCategories | slice : 0 : catLoadCount">
            <li>
              <a (click)="searchText = category.name">
                <p>{{category.name}}</p>
                <p>{{category.count}}</p>
              </a>
            </li>
          </ng-container>
        </ul>
          <button *ngIf="postCategories.length > 0 && postCategories.length !== catLoadCount" class="load-more" (click)="loadMoreCats()">Load more</button>
      </div>
    </div>
  </div>
</div>
